export function round(number: number, fractionDigits: number = 0) {
  return parseFloat(number.toFixed(fractionDigits));
}
